import {gql} from "apollo-angular";
import {basePageableGraphqlField, baseResponseGraphqlField} from "../../../base.graphql";

export const citizenServicesField = `
  id
  serviceUniqueId
  serviceName
  serviceDescription
  serviceGroups {
    id
    groupUniqueId
    groupType
  }
  serviceForm {
    id
    hasForm
    formType
  }
  serviceCategory {
    id
    categoryUniqueId
    categoryName
    categoryDescription
  }
  serviceResults {
    id
    resultUniqueId
    resultDescription
  }
  serviceProvider {
    id
    institutionUniqueId
    institutionName
    institutionShortform
    institutionPhysicalAddress
    institutionEmail
    institutionPostcode
    institutionWebsite
    institutionPhones
    institutionMapUrl
    institutionLogo
    institutionMinistry {
      id
      ministryUniqueId
      ministryName
    }
    institutionSector {
      id
      sectorUniqueId
      sectorName
      sectorIcon
    }
  }
`;

export const citizenServicesFieldFew = `
        id
        serviceUniqueId
        serviceIsSubService
        serviceName
        serviceDescription
        serviceProvider {
          institutionName
        }
`;


export const GET_CITIZEN_SERVICES = gql`
  query CitizenGetServices($filtering: ServiceInstitutionFilterInputObject){
    citizenGetServices(filtering:$filtering){
      ${baseResponseGraphqlField}
      ${basePageableGraphqlField}
      data {
        ${citizenServicesField}
      }
    }
  }
`;

export const GET_CITIZEN_SERVICES_FEW = gql`
  query CitizenGetServices($filtering: ServiceInstitutionFilterInputObject){
    citizenGetServices(filtering:$filtering){
      ${baseResponseGraphqlField}
      ${basePageableGraphqlField}
      data {
        ${citizenServicesFieldFew}
      }
    }
  }
`;


export const GET_REQUESTED_SERVICES = gql`
  query GetCitizenServices {
    getCitizenServices {
      data {
        ${citizenServicesFieldFew}
      }
    }
  }
`

export const CITIZEN_GET_ALL_SERVICES_BY_LOCATION = gql`
  query CitizenGetAllServicesByLocation($filtering: ServiceBranchFilteringObject) {
    citizenGetAllServicesByLocation(filtering: $filtering) {
      ${baseResponseGraphqlField}
      ${basePageableGraphqlField}
      data {
        ${citizenServicesField}
        serviceIsSubService
        serviceName
        serviceIsApproved
        serviceHasSubService
        serviceHasCoProviders
        serviceCoProviders {
          id
          coproviderUniqueId
          coproviderCollaborationPurpose
          coproviderInstitution {
            id
            institutionUniqueId
            institutionName
            institutionShortform
            institutionPhysicalAddress
            institutionEmail
            institutionPostcode
            institutionWebsite
            institutionPhones
            institutionMapUrl
            institutionLogo
          }
        }
        serviceHasOpponents
        serviceOpponents {
          id
          opponentUniqueId
          opponentInstitution {
            id
            institutionUniqueId
            institutionName
            institutionShortform
            institutionPhysicalAddress
            institutionEmail
            institutionPostcode
            institutionWebsite
            institutionPhones
            institutionMapUrl
            institutionLogo
          }
        }
        serviceApprovalStage {
          id
          stageUniqueId
          stageName
          stageIsStarting
          stageIsEnding
          stageDesignation {
            id
            designationUniqueId
            designationShortForm
            designationName
          }
        }
        serviceSentPopsmgg
        serviceIsRejected
      }
    }
  }
`


export const GET_CITIZEN_SERVICES_SECTOR = gql`
  query CitizenGetServicesFromSector($sectorUniqueId: String!, $filtering: ServiceInstitutionFilterInputObject) {
    citizenGetServicesFromSector(sectorUniqueId: $sectorUniqueId, filtering: $filtering) {
      ${baseResponseGraphqlField}
      ${basePageableGraphqlField}
      data {
        ${citizenServicesField}
      }
    }
  }
`;

export const GET_CITIZEN_SERVICES_SECTOR_FEW = gql`
  query CitizenGetServicesFromSector($sectorUniqueId: String!, $filtering: ServiceInstitutionFilterInputObject) {
    citizenGetServicesFromSector(sectorUniqueId: $sectorUniqueId, filtering: $filtering) {
      ${baseResponseGraphqlField}
      ${basePageableGraphqlField}
      data {
        ${citizenServicesFieldFew}
      }
    }
  }
`;


export const GET_CITIZEN_SERVICES_FROM_SOCIAL_GROUPS = gql`
  query CitizenGetServicesFromSocialGroups($filtering: SocialGroupFilteringInputObject) {
    citizenGetServicesFromSocialGroups(filtering: $filtering) {
      ${baseResponseGraphqlField}
      ${basePageableGraphqlField}
      data {
        ${citizenServicesField}
      }
    }
  }
`

